import React,{useRef,useEffect} from 'react';  
import CheckItOut from '../components/CheckItOut'
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
  } from 'semantic-ui-react'
  import LazyLoad from 'react-lazy-load';
function DetailsPage(props)
{
 
    return <div>
         <LazyLoad  height={50}><div></div></LazyLoad> 
        <Container text>
          <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            <i>Cascade Tactics  </i>has many interesting mechanics!
          </Header>
          </Container>
        <Divider></Divider>
        <CheckItOut></CheckItOut>
        <Divider></Divider>
      
        <Grid  columns='equal' stackable> 
        <Grid.Row textAlign='center'>
                <Grid.Column width={16} style={{paddingBottom:'0em', paddingTop:'0em'}}>  
                <Container text>
                    <Header  inverted as='h3' color='blue'   style={{fontSize:'1.5em'}}>
                        You can change the camera angle or peek inside of buildings
                    </Header>
                    </Container>
                </Grid.Column>
            </Grid.Row> 
            <Grid.Row textAlign='center'>
                <Grid.Column width={16} style={{paddingBottom:'1em', paddingTop:'1em'}}>   
                    <img src={"/gifs/Rotate1.gif"}  style={{width:Math.min(800,props.width), height:'auto'}}></img> 
                </Grid.Column>
            </Grid.Row>
            <Grid.Row textAlign='center'>
                <Grid.Column width={16} style={{paddingBottom:'1em', paddingTop:'1em'}}>   
                    <img src={"/gifs/BigCastle.gif"}  style={{width:Math.min(800,props.width), height:'auto'}}></img> 
                </Grid.Column>
            </Grid.Row>
        </Grid>
        
    </div>
}

export default DetailsPage